/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Feedback_PlaceholderInputs */

const en_dialog_feedback_placeholder = /** @type {(inputs: Dialog_Feedback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knowing what we did wrong will help us make the app better.`)
};

const es_dialog_feedback_placeholder = /** @type {(inputs: Dialog_Feedback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saber qué hicimos mal nos ayudará a mejorar la app.`)
};

/**
* | output |
* | --- |
* | "Knowing what we did wrong will help us make the app better." |
*
* @param {Dialog_Feedback_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_feedback_placeholder = /** @type {((inputs?: Dialog_Feedback_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Feedback_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_feedback_placeholder(inputs)
	return en_dialog_feedback_placeholder(inputs)
});